export function normalizeRegistrationAuthUrl(value, expected) {
  try {
    if (typeof value !== 'string' || value.length > 4096) {
      return '';
    }
    if (!/^[\x20-\x7E]+$/.test(value) || value.includes('\\') || value.includes('#')) {
      return '';
    }
    const prefix = 'https://victoriyaclub.com/?';
    if (!value.startsWith(prefix)) {
      return '';
    }

    if (!expected || typeof expected !== 'object') {
      return '';
    }
    const rawEmailCtx = expected.email;
    const rawPidCtx = expected.pid;
    const rawSidCtx = expected.sid;

    if (typeof rawEmailCtx !== 'string' || rawEmailCtx.length > 254) {
      return '';
    }
    const normEmailCtx = rawEmailCtx.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/.test(normEmailCtx) || /[^\x21-\x7E]/.test(normEmailCtx)) {
      return '';
    }

    if (typeof rawPidCtx !== 'string' || !/^\d{1,20}$/.test(rawPidCtx)) {
      return '';
    }
    if (typeof rawSidCtx !== 'string' || !/^\d{1,20}$/.test(rawSidCtx)) {
      return '';
    }

    const queryString = value.slice(prefix.length);
    if (queryString.length === 0) {
      return '';
    }

    const pairs = queryString.split('&');
    const allowedKeys = new Set(['email', 'password', 'pid', 'sid', 'landing_reg', 'token']);
    const seenKeys = new Set();
    const parsedParams = [];

    let hasEmail = false;
    let hasDigest = false;
    let hasPid = false;
    let hasSid = false;
    let hasLandingReg = false;
    let hasSession = false;

    let digestValue = '';
    let sessionValue = '';
    let emailValue = '';
    let pidValue = '';
    let sidValue = '';
    let landingRegValue = '';

    for (const pair of pairs) {
      if (pair === '') {
        return '';
      }
      const eqIdx = pair.indexOf('=');
      if (eqIdx === -1) {
        return '';
      }
      const k = pair.slice(0, eqIdx);
      const rawV = pair.slice(eqIdx + 1);

      if (!allowedKeys.has(k)) {
        return '';
      }
      if (seenKeys.has(k)) {
        return '';
      }
      seenKeys.add(k);

      let decodedV;
      try {
        decodedV = decodeURIComponent(rawV);
      } catch (e) {
        return '';
      }

      if (/[^\x21-\x7E]/.test(decodedV)) {
        return '';
      }

      if (k === 'email') {
        hasEmail = true;
        emailValue = decodedV;
      } else if (k === 'password') {
        hasDigest = true;
        digestValue = decodedV;
      } else if (k === 'pid') {
        hasPid = true;
        pidValue = decodedV;
      } else if (k === 'sid') {
        hasSid = true;
        sidValue = decodedV;
      } else if (k === 'landing_reg') {
        hasLandingReg = true;
        landingRegValue = decodedV;
      } else if (k === 'token') {
        hasSession = true;
        sessionValue = decodedV;
      }

      parsedParams.push({ k, v: decodedV });
    }

    if (!hasEmail || !hasDigest || !hasPid || !hasSid) {
      return '';
    }

    if (hasLandingReg !== hasSession) {
      return '';
    }

    if (emailValue !== normEmailCtx) {
      return '';
    }

    if (!/^[a-f0-9]{32}$/.test(digestValue)) {
      return '';
    }

    if (pidValue !== rawPidCtx || sidValue !== rawSidCtx) {
      return '';
    }

    if (hasLandingReg) {
      if (landingRegValue !== '1') {
        return '';
      }
      if (!/^[A-Za-z0-9._~-]{32,1536}$/.test(sessionValue)) {
        return '';
      }
    }

    const rfcEncode = (s) => {
      return encodeURIComponent(s).replace(/[!'()*]/g, c => '%' + c.charCodeAt(0).toString(16).toUpperCase());
    };

    const serializedQuery = parsedParams.map(({ k, v }) => k + '=' + rfcEncode(v)).join('&');
    const resultUrl = prefix + serializedQuery;

    if (resultUrl.length > 4096) {
      return '';
    }

    return resultUrl;
  } catch (err) {
    return '';
  }
}
